import { dateTransformer } from 'apis/transformers/date'

import { menuCutoffUntilReceive } from './menu'

// The name of the function is misleading: what it does is loading a `menuCutoffUntil` into state, but do not load a days
export function menuServiceLoadDays(dispatch, getState) {
  const menuServiceData = getState().menuService
  const transformedDate = dateTransformer(menuServiceData)

  dispatch(menuCutoffUntilReceive(transformedDate))
}
